export const CURRENT_CONFIG = {

  // license
  appId: '158608',
  appKey: '0067a0dfc19acec8b823cb3433afdff',
  appLicense: 'SxHGQ/ouNpAT0NfIIx/bSA6StRwI2itxNCvIgQfgxX2t8LukJzBAHrwT7eVAxMLs7AnoRPIAb6Cjm3emaa5qViT5yb021l5UkqIdj7Ct0jIueQk4wArWhBhCDGghN2cwloqImbl5ZSbnhogye2MXerZRzndGisLs6bUbzLFCwC0=',

  // http
  baseURL: 'https://api.develop.drone.hunterra.eu/', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  websocketURL: 'wss://api.develop.drone.hunterra.eu/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws'

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'Please enter the rtmp access address.', // Example: 'rtmp://192.168.1.1/live/'
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: 'Please enter the server ip.',
  gbServerPort: 'Please enter the server port.',
  gbServerId: 'Please enter the server id.',
  gbAgentId: 'Please enter the agent id',
  gbPassword: 'Please enter the agent password',
  gbAgentPort: 'Please enter the local port.',
  gbAgentChannel: 'Please enter the channel.',
  // RTSP
  rtspUserName: 'Please enter the username.',
  rtspPassword: 'Please enter the password.',
  rtspPort: '8554',
  // Agora
  agoraAPPID: 'Please enter the agora app id.',
  agoraToken: 'Please enter the agora temporary token.',
  agoraChannel: 'Please enter the agora channel.',

  // map
  // You can apply on the AMap website.
  amapKey: 'Please enter the amap key.',

}
